function getDomain() {
    return process.env.REACT_APP_REFSIX_AUTH_URL;
}

const apiDomain = getDomain();

export { apiDomain };
